<template>
  <div class="wrapper bg-login-main">
    <!-- Forgot Password Page Start -->
    <div class="m-account-w">
      <div class="m-account">
        <div class="row no-gutters">
          <div class="col-md-12">
            <!-- Forgot Password Form Start -->
            <div class="m-account--form-w">
              <div class="">
                <div @click="abrirLogin" class="back-login">
                  <i class="mdi mdi-arrow-left arrow-back"></i>
                </div>
                <div class="text-center">
                  <img
                    class="d-block mx-auto mb-4"
                    src="@/assets/images/logos/logo-dark.jpg"
                    alt=""
                  />
                  <h2 class="text-secondary">Cadastro de Novo Usuário</h2>
                  <p class="text-black">
                    Preencha todos os dados obrigatórios e clique em cadastrar.
                  </p>
                </div>

                <div class="row g-5">
                  <div class="col-md-12 col-lg-12">
                    <h4 class="mb-3">Dados do Usuário</h4>
                    <form class="needs-validation" novalidate>
                      <div class="row">
                        <div class="col-md-6">
                          <input-text
                            :label="$t('USUARIOS.NOME_COMPLETO')"
                            ref="nome"
                            id="nome"
                            placeholder=""
                            v-model="form.nome"
                            value=""
                            required
                          />
                        </div>

                        <!--<div class="form-group col-md-6">
                          <input-date-time label="Data de nascimento" ref="data_nascimento" v-model="form.dataNascimento" required />
                        </div>-->

                        <div class="form-group col-md-6">
                          <input-mask
                            type="cnpj"
                            :mask="['##.###.###/####-##']"
                            :label="$t('GERAL.CNPJ_EMPRESA')"
                            ref="cnpjEmpresa"
                            v-model="form.cnpjEmpresa"
                            id="cnpjEmpresa"
                            placeholder=""
                            value=""
                            required
                          />
                        </div>

                        <div class="form-group col-md-6">
                          <input-select
                            required
                            ref="nacionalidade"
                            :label="$t('USUARIOS.NACIONALIDADE')"
                            v-model="form.nacionalidade"
                            :options="nacionalidade"
                            id="nacionalidade"
                          />
                        </div>

                        <div
                          class="form-group col-md-6"
                          v-if="form.nacionalidade != 'Estrangeira'"
                        >
                          <input-mask
                            type="cpf"
                            :mask="['###.###.###-##']"
                            :label="$t('USUARIOS.CPF')"
                            ref="cpf"
                            v-model="form.cpf"
                            id="cpf"
                            placeholder=""
                            value=""
                            required
                          />
                        </div>

                        <div
                          v-if="form.nacionalidade == 'Estrangeira'"
                          class="form-group col-md-6"
                        >
                          <input-text
                            ref="passaporte"
                            :label="$t('USUARIOS.PASSAPORTE')"
                            id="passaporte"
                            v-model="form.passaporte"
                            placeholder=""
                            value=""
                            required
                          />
                        </div>

                        <div class="form-group col-md-6">
                          <input-select
                            required
                            :label="$t('USUARIOS.TITULACAO')"
                            ref="titulacao"
                            :options="titulacao"
                            v-model="form.titulacao"
                            id="titulacao"
                          />
                        </div>

                        <!--<div class="form-group col-md-6">
                          <input-mask :mask="['(##) ####-####', '(##) #####-####']" :label="$t('USUARIOS.TELEFONE')" ref="telefone" id="telefone" v-model="form.telefone" placeholder="" value="" required />
                        </div>-->

                        <div class="form-group col-md-6">
                          <input-mask
                            :mask="['(##) ####-####', '(##) #####-####']"
                            ref="celular"
                            :label="$t('USUARIOS.CELULAR')"
                            id="celular"
                            v-model="form.celular"
                            placeholder=""
                            value=""
                            required
                          />
                        </div>

                        <div
                          v-if="form.nacionalidade != 'Estrangeira'"
                          class="form-group col-md-6"
                        >
                          <input-select
                            required
                            ref="uf"
                            :label="$t('USUARIOS.ESTADO_NOME')"
                            :options="options.estado"
                            v-model="form.endereco.uf"
                            id="estado"
                          />
                        </div>

                        <div
                          v-if="form.nacionalidade != 'Estrangeira'"
                          class="form-group col-md-6"
                        >
                          <input-select
                            required
                            ref="cidade"
                            :label="$t('USUARIOS.CIDADE_NOME')"
                            :options="options.cidades"
                            v-model="form.endereco.cidade"
                            id="cidade"
                          />
                        </div>

                      </div>
                      <hr class="m-5" />
                    </form>

                    <h4 class="mb-3">Dados de Login</h4>
                    <form class="needs-validation" novalidate>
                      <div class="row">
                        <div class="form-group col-md-6">
                          <input-text
                            ref="nomeUsuario"
                            :label="$t('USUARIOS.USUARIO')"
                            id="usuario"
                            v-model="form.nomeUsuario"
                            placeholder=""
                            value=""
                            required
                          />
                          <b-badge
                            v-if="naoDeveConterEspacoECaracteresEspeciais"
                            :variant="naoDeveConterEspacoECaracteresEspeciais.variant"
                          >
                            {{ naoDeveConterEspacoECaracteresEspeciais.text }}
                          </b-badge>
                        </div>
                        <div class="form-group col-md-6">
                          <input-text
                            ref="email"
                            type="email"
                            :label="$t('USUARIOS.EMAIL')"
                            id="email"
                            v-model="form.email"
                            placeholder=""
                            value=""
                            required
                          />
                        </div>
                        <div class="form-group col-md-6">
                          <input-text
                            ref="senha"
                            type="password"
                            :label="$t('USUARIOS.SENHA')"
                            id="senha"
                            v-model="form.senha"
                            placeholder=""
                            value=""
                            required
                            autocomplete="off"
                            :showPassword="true"
                          />
                          <b-badge
                            v-if="deveConter6Caracteres"
                            :variant="deveConter6Caracteres.variant"
                          >
                            {{ deveConter6Caracteres.text }}
                          </b-badge>
                          <br />
                          <b-badge
                            v-if="deveConterLetraMinuscula"
                            :variant="deveConterLetraMinuscula.variant"
                          >
                            {{ deveConterLetraMinuscula.text }}
                          </b-badge>
                          <br />
                          <b-badge
                            v-if="deveConterLetraMaiuscula"
                            :variant="deveConterLetraMaiuscula.variant"
                          >
                            {{ deveConterLetraMaiuscula.text }}
                          </b-badge>
                          <br />
                          <b-badge
                            v-if="deveConterCaracterEspecial"
                            :variant="deveConterCaracterEspecial.variant"
                          >
                            {{ deveConterCaracterEspecial.text }}
                          </b-badge>
                          <br />
                          <b-badge
                            v-if="deveConterNumero"
                            :variant="deveConterNumero.variant"
                          >
                            {{ deveConterNumero.text }}
                          </b-badge>
                        </div>

                        <div class="form-group col-md-6">
                          <input-text
                            ref="confirmacaoSenha"
                            type="password"
                            :label="$t('USUARIOS.CONFIRMACAO_SENHA')"
                            id="confirmacaoSenha"
                            v-model="form.confirmacaoSenha"
                            placeholder=""
                            value=""
                            required
                            autocomplete="off"
                            :showPassword="true"
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                <div class="form-group pt-3 d-flex">
                  <label class="form-check">
                    <b-checkbox
                      type="checkbox"
                      name="checkbox"
                      value="1"
                      class="form-check-input"
                      v-model="termosCheck"
                    />
                  </label>
                  <span class="form-check-label mt-1">
                    Li e concordo com os
                    <a @click="abrirTermos" class="text-blue-300"
                      >Termos do Serviço</a
                    >
                    e
                    <a class="text-blue-300" @click="abrirPolitica">
                      Política de Privacidade
                    </a>
                  </span>
                </div>
                <hr />
                <b-button
                  :disabled="!termosCheck"
                  @click="cadastrar"
                  class="btn btn-primary mx-auto btn-cadastrar"
                >
                  CADASTRAR
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <termos title="Termos de Serviço" />
    <politica title="Política de Privacidade" />
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  email,
  maxLength,
} from "vuelidate/lib/validators";
import InputText from "@/components/inputs/InputText";
import InputMask from "@/components/inputs/InputMask";
import InputSelect from "@/components/inputs/InputSelect";
//import InputDateTime from "@/components/inputs/InputDateTime";

import AprovacaoService from "@/common/services/usuario/aprovacao.service";
import InfosService from "@/common/services/infos/infos.service";

import Swal from "sweetalert2";
import Termos from "./components/Termos.vue";
import Politica from "./components/Politica.vue";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

import UF from "@/common/mock/UF";

export default {
  name: "FullRegister",
  mixins: [validationMixin],
  components: {
    Termos,
    Politica,
    InputText,
    InputMask,
    InputSelect,
    //InputDateTime,
    // ModalEsqueceuSenha,
  },
  data: () => ({
    nacionalidade: [
      {
        value: "Brasileira",
        text: "Brasileira",
      },
      {
        value: "Estrangeira",
        text: "Estrangeira",
      },
    ],
    titulacao: [
      {
        value: "Doutor",
        text: "Doutor",
      },
      {
        value: "Mestre",
        text: "Mestre",
      },
      {
        value: "Especialista",
        text: "Especialista",
      },
      {
        value: "Superior",
        text: "Superior",
      },
      {
        value: "Tecnico",
        text: "Técnico",
      },
    ],
    options: {
      estado: UF,
      cidades: []
    },
    timeBuscar: undefined,
    form: {
      nomeUsuario: "",
      nome: "",
      nacionalidade: "",
      cpf: "",
      cnpjEmpresa: "",
      passaporte: "",
      titulacao: "",
      email: "",
      senha: "",
      confirmacaoSenha: "",
      telefone: "",
      celular: "",
      dataNascimento: "",
      foto: "",
      endereco: {
        /*logradouro: "",
        numero: "",
        cep: "",
        complemento: "",
        bairro: "",*/
        cidade: "",
        uf: "",
      },
    },
    termosCheck: false,
    salvando: false,
  }),
  validations: {
    form: {
      nomeUsuario: {
        required,
        minLength: minLength(4),
      },
      email: {
        required,
        email,
        maxLength: maxLength(10),
      },
      senha: {
        required,
        minLength: minLength(8),
      },
    },
  },
  watch: {
    "form.endereco.uf": function () {
      InfosService.buscarCidades(this.form.endereco.uf).then((res) => {
        this.options.cidades = res.data.data.map(el => {
          return {
            text: el.nome,
            value: el.nome
          }
        })
      });
    }
  },
  methods: {
    changeCep() {
      if (this.form.endereco.cep.length >= 8 && this.salvando == false) {
        this.buscarEndereco();
      }
    },
    abrirLogin() {
      this.$router.push({ name: "Login" });
    },
    abrirTermos() {
      this.$bvModal.show("modal-termos");
    },
    abrirPolitica() {
      this.$bvModal.show("modal-politica");
    },

    validateState() {
      // const { $dirty, $error } = this.$v.form[username];
      // return $dirty ? !$error : null;

      let arValidation = [];

      if (this.$refs.nacionalidade.value == "Estrangeira") {
        arValidation.push(this.$refs.passaporte.valid());
      } else {
        arValidation.push(this.$refs.cidade.valid());
        arValidation.push(this.$refs.uf.valid());
        arValidation.push(this.$refs.cpf.valid());
      }

      arValidation.push(this.$refs.nome.valid());
      arValidation.push(this.$refs.nacionalidade.valid());
      arValidation.push(this.$refs.titulacao.valid());
      //arValidation.push(this.$refs.telefone.valid());
      arValidation.push(this.$refs.celular.valid());
      arValidation.push(this.$refs.email.valid());
      //arValidation.push(this.$refs.data_nascimento.valid());
      arValidation.push(this.$refs.senha.valid());
      arValidation.push(this.$refs.confirmacaoSenha.valid());
      arValidation.push(this.$refs.nomeUsuario.valid());
      arValidation.push(this.$refs.cnpjEmpresa.valid());

      return arValidation.filter((elem) => elem == false).length == 0;
    },
    cadastrar() {
      if (this.validateState() == false) return;
      if (!this.senhaValida) {
        this.alertaErro(
          "A senha não atende os requisitos mínimos de segurança"
        );
        return;
      }
      this.salvando = true;

      this.$store.dispatch(START_LOADING);

      this.form.confirmacaoSenha = this.form.senha;

      this.form.cpf = this.form.cpf.replace(/[^0-9]/g, "");
      this.form.cnpjEmpresa = this.form.cnpjEmpresa.replace(/[^0-9]/g, "");
      this.form.celular = this.form.celular.replace(/[^0-9]/g, "");

      AprovacaoService.salvarUsuario(this.form)
        .then(() => {
          this.salvando = false;
          this.form = {};
          Swal.fire({
            title: this.$t("GERAL.SUCCESSO"),
            text: "Cadastro efetuado com sucesso!",
            icon: "success",
          }).then(() => {
            this.$router.push({ name: "Login" });
          });
        })
        .catch((err) => {
          Swal.fire({
            title: this.$t("GERAL.ERRO"),
            text: err.response.data.errors,
            icon: "error",
          });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
  computed: {
    senhaValida: function () {
      if (
        this.deveConter6Caracteres &&
        this.deveConter6Caracteres.variant == "success" &&
        this.deveConterLetraMaiuscula &&
        this.deveConterLetraMaiuscula.variant == "success" &&
        this.deveConterLetraMinuscula &&
        this.deveConterLetraMinuscula.variant == "success" &&
        this.deveConterCaracterEspecial &&
        this.deveConterCaracterEspecial.variant == "success" &&
        this.deveConterNumero &&
        this.deveConterNumero.variant == "success"
      )
        return true;
      return false;
    },
    deveConter6Caracteres: function () {
      if (!this.form.senha) return null;
      if (this.form.senha.length < 6)
        return {
          variant: "danger",
          text: "Deve conter no mínimo 6 caracteres",
        };
      return {
        variant: "success",
        text: "Deve conter no mínimo 6 caracteres",
      };
    },
    deveConterLetraMinuscula: function () {
      var letraMinuscula = /([a-z])/;
      if (!this.form.senha) return null;
      if (this.form.senha.match(letraMinuscula))
        return {
          variant: "success",
          text: "Deve conter letra minúscula",
        };
      return {
        variant: "danger",
        text: "Deve conter letra minúscula",
      };
    },
    deveConterLetraMaiuscula: function () {
      var letraMaiusculas = /([A-Z])/;
      if (!this.form.senha) return null;
      if (this.form.senha.match(letraMaiusculas))
        return {
          variant: "success",
          text: "Deve conter letra maiúsculas",
        };
      return {
        variant: "danger",
        text: "Deve conter letra maiúsculas",
      };
    },
    deveConterCaracterEspecial: function () {
      var chEspeciais = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<,.])/;
      if (!this.form.senha) return null;
      if (this.form.senha.match(chEspeciais))
        return {
          variant: "success",
          text: "Deve conter caractere especial",
        };
      return {
        variant: "danger",
        text: "Deve conter caractere especial",
      };
    },
    deveConterNumero: function () {
      var numeros = /([0-9])/;
      if (!this.form.senha) return null;
      if (this.form.senha.match(numeros))
        return {
          variant: "success",
          text: "Deve conter número",
        };
      return {
        variant: "danger",
        text: "Deve conter número",
      };
    },
    naoDeveConterEspacoECaracteresEspeciais: function () {
      var specialCaracters = /[^\w\\.]/
      if (!this.form.nomeUsuario) return null;
      if (this.form.nomeUsuario.match(specialCaracters))
      return {
          variant: "danger",
          text: "Não deve conter espaçamento e caracteres especiais",
        };
      return {
        variant: "success",
        text: "Não deve conter espaçamento e caracteres especiais",
      };
    },
  },
};
</script>
